module.exports = __webpack_public_path__ + "fcaf806e6c1434422cdd24d1edd26403.png";